import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { useIntl } from "react-intl";
import { temp_store } from "../../../modules/function/temp_store"
import { useSelector } from "react-redux";



export const CreateSpec = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const history = useHistory();
    const [key, setKey] = useState("")
    const [datatemp, setData] = useState([])
    const [textbox, setTextbox] = useState([])
    const [grouplist, setGrouplist] = useState([])
    const [keylist, setKeylist] = useState([])
    const [show, setShow] = useState(false)
    const [group, setGroup] = useState([])
    const [value, setValue] = useState()

    const { user } = useSelector((state) => state.auth);



    useEffect(() => {
        /*setMapData(props.location.state.key)
        setTextbox(props.location.state.key)*/
        console.log(props.location.state)
        getList()
    }, []);

    suhbeader.setTitle(`Create Spec`);
    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const AlertError = (message) => {
        Swal.fire("Alert", message, "error");
    };

    const getList = async () => {
        const apiUrls = `${baseURLV1}/specGroup?page=1&limit=10000`;
        let token = localStorage.getItem("Token");

        await axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {

                console.log(res.data)

                setGrouplist(res.data.data)
            })
            .catch((err) => {
                if (err.response) {

                }
            });
    };

    const onSubmit = async () => {
        if (key === undefined || key === "") {
            return AlertError("Please insert key !!");
        }

        if (value === undefined || value === "") {
            return AlertError("Please insert value !!");
        }

        let apiUrls = `${baseURLV1}/specvalue`;
        let token = localStorage.getItem("Token");
        console.log(datatemp)
        axios({
            method: "post",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: {
                product_id: String(props.location.state.data.id),
                key_id: String(key),
                value: value,
            }
        }).then(async (res) => {
            history.goBack();
        })
            .catch((err) => {
                Swal.fire(
                    "Create !",
                    "Your can not Create Spec. !! " + err,
                    "error"
                );
            });
    };

    const changeKey = async(data) => {
        setGroup(data)
        setKey('')
        const apiUrls = `${baseURLV1}/speckeys/${props.location.state.data.id}?group=${data}`;
        let token = localStorage.getItem("Token");

        await axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {

                console.log(res.data)

                setKeylist(res.data)
                setShow(true)
            })
            .catch((err) => {
                if (err.response) {

                }
            });

    }



    return (
        <>
            <Card>
                <CardHeader title={"Create Spec"}></CardHeader>
                <CardBody>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Group Name" })}:{" "}
                        </p>
                        <select
                            as="select"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={group}
                            onChange={e => changeKey(e.target.value)}
                        >
                            <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
                            {grouplist &&
                                grouplist.map((result, index) => {
                                    return (
                                        <option key={index} value={result.id}>
                                            {result.groupname}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>

                    {show && (<div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Spec Name" })}:{" "}
                        </p>
                        <select
                            as="select"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={key}
                            onChange={e => setKey(e.target.value)}
                        >
                            <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
                            {keylist &&
                                keylist.map((result, index) => {
                                    return (
                                        <option key={index} value={result.id}>
                                            {result.key}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>)}

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Value" })}:{" "}
                        </p>
                        <input
                            name="modelGroup"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    </div>

                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <Link to="/EditSpecCompare">
                            <button type="button" className="btn btn-secondary wbt mr-5">
                                {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
                            </button>
                        </Link>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
                        </button>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
